import React from "react";
import SocialMediaLinksView from "./view";

const SocialMediaLinksPage = () => {
  return <SocialMediaLinksView />;
};

export default SocialMediaLinksPage;